import React from "react";
import {ButtonLinkStyle} from "../../../Components/Inputs";
import {HtmlDisplay} from "../../../Components/Display/HtmlDisplay";
import {GridCell} from "../../../Components/Grid";
import {locations} from "../../../Utilities/Location";

interface OrderPrintBarcodeProps {
    barcodes: string[];
    catalogCopyId?: string;
    redirect?: (path: string) => void;
}

export const OrderPrintBarcode = ({
                                      barcodes,
                                      catalogCopyId="",
                                      redirect
                                  }: OrderPrintBarcodeProps) => {
    const handlePrintBarcodeClick = () => {
        redirect?.(locations.DYMO_PRINT_LABEL.getLink([catalogCopyId]).to);
    }

    const displayPrintBarcode = catalogCopyId && redirect;

    return <>
        {
            displayPrintBarcode &&
            <GridCell>
                <ButtonLinkStyle
                    isPrimary isCollapsed
                    label={'Print Barcodes'}
                    name={`btnPrintBarcode`}
                    onClick={handlePrintBarcodeClick}/>
            </GridCell>
        }
        {
            barcodes.map((barcode: string, index: number) => {

                return <GridCell key={`${barcode}-${index}`}>
                    <HtmlDisplay html={`<b>` + barcode + `</b>`}/>
                </GridCell>;
            })
        }
    </>;
};

